import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import { positions, sizes, textAlignments, colors } from "../../../enums";
import classnames from 'classnames';
import { Segment as UISegment } from 'semantic-ui-react';
var UNSUPPORTED_PROPS = ['as', 'basic', 'circular', 'className', 'clearing', 'content', 'disabled', 'floated', 'inverted', 'loading', 'padded', 'piled', 'raised', 'secondary', 'stacked', 'tertiary', 'vertical'];
var ADDED_PROPS = ['float', 'hasMargins', 'hasPadding', 'isBasic', 'isCompact', 'isDisabled', 'isInverted', 'isLoading'];
var MODIFIED_PROPS = ['color'];
var propMap = {
  "float": 'floated',
  hasMargins: 'vertical',
  hasPadding: 'padded',
  isBasic: 'basic',
  isCompact: 'compact',
  isDisabled: 'disabled',
  isInverted: 'inverted',
  isLoading: 'loading'
};
var Segment = createComponent({
  displayName: 'Segment',
  propTypes: {
    children: PropTypes.node.isRequired,
    attached: PropTypes.oneOf(positions.WITHOUT_SIDES),
    color: PropTypes.oneOf(colors.CORE),
    "float": PropTypes.oneOf(positions.LR),
    hasMargins: PropTypes.bool,
    hasPadding: PropTypes.bool,
    isBasic: PropTypes.bool,
    isCompact: PropTypes.bool,
    isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    size: PropTypes.oneOf(sizes.ALL),
    textAlign: PropTypes.oneOf(textAlignments.ALL)
  },
  defaultProps: {
    color: null,
    // transparent segment by default
    attached: null,
    "float": null,
    hasMargins: false,
    hasPadding: false,
    isBasic: false,
    isCompact: false,
    isDisabled: false,
    isLoading: false,
    size: null,
    textAlign: textAlignments.LEFT
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    delete UIProps.children;
    UIProps.className = classnames(props.color);
    return /*#__PURE__*/React.createElement(UISegment, UIProps, props.children);
  }
});
export default Segment;
//# sourceMappingURL=index.js.map